import { RichTextNode } from '@/common/components/RichText/RichTextService';
import LocalizedLink from '@/common/components/LocalizedLink/LocalizedLink';
import { getPageById } from '@/common/components/RichText/components/InternalLink/InternalLinkService';

interface InternalLinkProps {
  node: RichTextNode;
}

export default async function InternalLink({ node }: InternalLinkProps) {
  const targetId = (node.data as { target: { sys: { id: string } } }).target.sys
    .id;
  const linkText = node.content?.map((child, index) => (
    <span key={index}>{child.value}</span>
  ));

  if (!targetId) {
    return null;
  }

  const page = await getPageById(targetId);

  if (!page) {
    console.error(
      `Tried to render an internal link, but the page with id ${targetId} does not exist`
    );
    return null;
  }

  const slug = page.slug;

  if (!slug || slug === '') {
    console.error(
      `Tried to render an internal link, but the page with id ${targetId} does not have a slug`
    );
    return null;
  }

  return <LocalizedLink href={`/${slug}`}>{linkText}</LocalizedLink>;
}
